<template>
  <span class="recorder-mount" aria-hidden="true"></span>
</template>

<script>
  import { record } from 'rrweb'

  const FLUSH_INTERVAL_MS = 10000
  const MAX_RECORDING_MS = 60000

  function _Uuid () {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
    return 'r-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10)
  }

  export default {
    name: 'recorder',
    // NOTE: these fields are intentionally NOT in data() — Vue 2 would run
    // observe() on every rrweb event pushed into `buffer`, and rrweb events
    // are deeply-nested DOM snapshots, so the recursive observe/defineReactive
    // walk overflows the stack (Maximum call stack size exceeded).
    created () {
      this.session_id = _Uuid()
      this.buffer = []
      this.stop_fn = null
      this.timer_id = null
      this.max_duration_id = null
    },
    mounted () {
      try {
        this.stop_fn = record({
          emit: this.On_Event
        })
      } catch (_) {
        this.stop_fn = null
      }
      this.timer_id = setInterval(this.Flush, FLUSH_INTERVAL_MS)
      this.max_duration_id = setTimeout(this.Stop_Recording, MAX_RECORDING_MS)
      document.addEventListener('visibilitychange', this.On_Visibility_Change)
      window.addEventListener('beforeunload', this.On_Before_Unload)
    },
    beforeDestroy () {
      document.removeEventListener('visibilitychange', this.On_Visibility_Change)
      window.removeEventListener('beforeunload', this.On_Before_Unload)
      if (this.timer_id) clearInterval(this.timer_id)
      if (this.max_duration_id) clearTimeout(this.max_duration_id)
      if (this.stop_fn) {
        try { this.stop_fn() } catch (_) { /* ignore */ }
        this.stop_fn = null
      }
      this.Flush()
    },
    methods: {
      On_Event (event) {
        this.buffer.push(event)
      },
      On_Visibility_Change () {
        if (document.visibilityState === 'hidden') this.Flush()
      },
      On_Before_Unload () {
        this.Flush()
      },
      Stop_Recording () {
        if (this.timer_id) {
          clearInterval(this.timer_id)
          this.timer_id = null
        }
        if (this.stop_fn) {
          try { this.stop_fn() } catch (_) { /* ignore */ }
          this.stop_fn = null
        }
        this.Flush()
      },
      Flush () {
        if (this.buffer.length === 0) return
        const chunk = this.buffer
        this.buffer = []
        this.$store.dispatch('send_replay_chunk', {
          session_id: this.session_id,
          chunk: chunk
        })
      }
    }
  }
</script>

<style lang="less">
  .recorder-mount {
    display: none;
  }
</style>
